import React, { Fragment } from "react";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import HomeContainer from "containers/Home/HomeContainer";

export default function HomePage() {
  return (
    <Fragment>
      <Header isFromPlanListing={true} />
      <div className="main_content">
        <HomeContainer />
      </div>
      <Footer />
    </Fragment>
  );
}
